if (!window.Eurus.loadedScript.has('window-scroll.js')) {
  window.Eurus.loadedScript.add('window-scroll.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xWindowScroll', {
        scrolled: false,

        updateScrollState() {
          this.scrolled = window.scrollY > 0;
        }
      });
      
      Alpine.store('xWindowScroll').updateScrollState();
      
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            Alpine.store('xWindowScroll').updateScrollState();
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    });
  });
}